define(['./base', 'jquery', 'underscore'], function (BaseHelper, $, _) {
  return BaseHelper.extend({
    options: {
      visibleClass: 'site-bottom-action-bar--visible',
      scrollThreshold: 0.8,
      triggerSelector: '.js-action-bar-scroll-trigger:eq(0)'
    },

    ui: {
      bar: '.js-action-bar',
      close: '.js-action-bar-close'
    },

    events: {
      'click @ui.close': 'hideBar'
    },

    hideBar: function () {
      this.ui.bar.css({
        opacity: 0,
        transform: 'translate(0, 100%)'
      })
    },

    getTriggerDimensions: function () {
      return this.triggerEl.offset()
    },

    getPageDimensions: function () {
      var $window = $(window)
      var scrollTop = $window.scrollTop()
      var windowHeight = $window.height()
      var innerPageHeight = $('html').height()

      return {
        scrollPositionInPage: scrollTop / (innerPageHeight - windowHeight),
        scrollBottom: scrollTop + windowHeight
      }
    },

    isTriggerVisible: function () {
      var pageDimensions = this.getPageDimensions()
      if (!this.triggerEl.size()) {
        return (
          pageDimensions.scrollPositionInPage > this.options.scrollThreshold
        )
      }

      var triggerDimensions = this.getTriggerDimensions()
      return triggerDimensions.top < pageDimensions.scrollBottom
    },

    updateBarState: function () {
      var isTriggerVisible = this.isTriggerVisible()

      if (isTriggerVisible === this.isBarVisible) return

      this.ui.bar.toggleClass(this.options.visibleClass, isTriggerVisible)
      this.isBarVisible = isTriggerVisible
    },

    initialize: function () {
      BaseHelper.prototype.initialize.apply(this, arguments)

      if (!this.ui.bar.size()) throw new Error('No ".js-action-bar" element found')
      this.isBarVisible = false
      this.triggerEl = this.$el.find(this.options.triggerSelector)
      this.updateBarState()
      $(window).on('scroll', _.debounce(this.updateBarState.bind(this), 200))
    }
  })
})
